import type { ReactNode } from "react";

export interface CompactTableColumn<T> {
  id: string;
  header: string;
  sortKey: keyof T;
  width: string;
  align?: "left" | "center" | "right";
  render: (row: T) => ReactNode;
}

export const clipText = (value: string | null | undefined, max = 70): string => {
  const text = value?.trim();
  if (!text) return "—";
  return text.length > max ? `${text.slice(0, max - 1)}…` : text;
};
